import {Localize} from "@dp-instant/i18n";
import {Action, di, lazyGet} from "@dp-instant/core";
import {useState} from "preact/hooks";
import {TypesFlow, TypesSocial} from "@dp-instant/interfaces";
import {IReferralRewardsModel, ISocial, IUser} from "@dp-instant/social";
import {TypesGame} from "@game/TypesGame";
import {Avatar, Button, useInjection} from "@dp-instant/ui";
import {ClaimButton} from "@game/ui/components/ClaimButton/ClaimButton";
import {SVG} from "@game/ui/images";
import {ILeaderobardItemProps, Reward} from "@game/ui/interface/ILeaderBoardProps";
import {GameModel} from "@game/coregame/model/GameModel";
import cn from "classnames";
import {playUIClickSound, isRankableUser} from "@game/helpers";
import {getFontClassByDigits} from "@game/ui/uiHelpers";

export const LeaderBoardItem = ({user, rank, isSolo = true}: ILeaderobardItemProps) => {
    const social: ISocial = useInjection(TypesSocial.model);
    const model: GameModel = useInjection(TypesGame.model);

    const isMe = user.origin === social.me;
    const canChallenge = user.origin !== social.opponent;
    const [selected, select] = useState(false);

    const onPlay = () => lazyGet<Action<IUser>>(TypesFlow.PlayWith)?.run(user.origin);

    const onClaim = async (reward: Reward, friendRef: string): Promise<any> => {
        di.get<IReferralRewardsModel<Reward>>(TypesSocial.refRewardsModel).claim(friendRef);
        model.cookie.coins += reward.count;
        select(true);
    };

    return (
        <>
            <li
                className={cn("leaderboard__item", {
                    leaderboard__item_me: isMe,
                    leaderboard__item_disabled: !canChallenge
                })}
            >
                <div
                    className={cn(
                        "leaderboard__item-rank",
                        getFontClassByDigits(
                            isRankableUser(user.origin) ? user.origin.getLbRecord()?.rank : rank,
                            2,
                            3
                        )
                    )}
                >
                    {isRankableUser(user.origin) ? user.origin.getLbRecord()?.rank : rank || "-"}
                </div>
                <Avatar imgPath={user.image_url} imgAlt={""} />
                <div
                    className={cn("leaderboard__item-info", {
                        "leaderboard__item-info_social": !isSolo
                    })}
                >
                    <div
                        className={cn("leaderboard__item-name", {
                            "leaderboard__item-name_social": !isSolo
                        })}
                    >
                        {user.name}
                    </div>
                    <div
                        className={cn("leaderboard__item-points", {
                            "leaderboard__item-points_social": !isSolo
                        })}
                    >
                        {isSolo ? (
                            <div className={cn("leaderboard__item-score-key")}>
                                {Localize.get("ui-menu-lvl", "LVL")}
                            </div>
                        ) : (
                            <div className={"cup-icon"}>
                                <SVG.LeaderBoardCupIcon />
                            </div>
                        )}

                        <div className={cn("leaderboard__item-score")}>{user.score || "-"}</div>
                    </div>
                </div>
                {isSolo ? (
                    user.reward && !selected ? (
                        <ClaimButton
                            reward={user.reward.count}
                            multiplierText=""
                            onClick={() => {
                                playUIClickSound();
                                user.reward && onClaim(user.reward, user.origin.id);
                            }}
                        />
                    ) : (
                        <>
                            <div className={cn("leaderboard__item-button")}>
                                {["ya", "pd"].includes(social.socialPlatform) ? null : (
                                    <Button
                                        className={cn("leaderboard__play-button")}
                                        onClick={() => {
                                            playUIClickSound();
                                            onPlay();
                                        }}
                                    >
                                        <SVG.LeaderBoardPlayIcon />
                                    </Button>
                                )}
                            </div>
                        </>
                    )
                ) : null}
            </li>
        </>
    );
};
